import React, { useRef, useState } from "react";
import "../css/CuM.css";
import { cufrontIcons } from "../../cufront-assets/icons/Icons";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useAtom } from "jotai";
import CuButton from "../../all-patient/components/CuButton";
import { MdEdit } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import {
  useCreateItem,
  useSecureDeleteItem,
  useUpdateItem,
} from "../../_helper/actions/mutation/items";
import moment from "moment";
import { toast } from "react-toastify";
import CuModal from "../../common_component/component/CuModal";
import Confirmation from "../../common_component/component/Confirmation";

const CuM = () => {
  const [showUserList, setShowUserList] = useState(false);
  const [comment, setComment] = useState("");
  const [isEditComment, setIsEditComment] = useState(false);
  const [editComment, setEditComment] = useState("");
  const [selectedIndex, setSelectedIndex] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [staffName, setStaffName] = useState("");
  const [taggedStaffId, setTaggedStaffId] = useState([]);
  const [clinic] = useAtom(clinicAtom);
  const textareaRef = useRef(null);
  const textEditAreaRef = useRef(null);

  // New state for edit comment mention
  const [showEditUserList, setShowEditUserList] = useState(false);
  // const [editStaffName, setEditStaffName] = useState("");

  const queryParams = new URLSearchParams(window.location.search);
  const editId = queryParams.get("editId");
  const viewId = queryParams.get("viewId");
  // //("eddit id--------", editId);

  const { data } = useItemsFilter(
    ApiEndPoint.BILLING_CREDIT_INVOICE,
    `?action=getInvoiceComments&backend=True&clinic_id=${
      clinic?.id
    }&invoice_id=${editId ? editId : viewId}`,
    clinic?.id && (editId || viewId) ? true : false
  );

  const { data: staffData, isLoading: staffLoading } = useItemsFilter(
    ApiEndPoint.CLINIC,
    `?action=getClinics&clinic_id=${clinic?.id}&backend=True&staff_name=${staffName}`,
    clinic?.id && (showUserList || showEditUserList) && staffName ? true : false
  );

  const postCommentMutation = useCreateItem(ApiEndPoint.BILLING_CREDIT_INVOICE);

  const handleSaveComment = () => {
    if (editId && !viewId) {
      if (!comment) {
        toast.error("Please enter a comment");
        return;
      }
      const payload = {
        action: "postInvoiceComments",
        clinic_id: clinic?.id,
        backend: "True",
        comments: comment,
        invoice_id: editId,
        taged_staff: taggedStaffId ? taggedStaffId : [],
      };
      postCommentMutation.mutate(payload, {
        onSuccess: (data) => {
          toast.success("Comment saved successfully");
          setComment("");
          setTaggedStaffId([]);
        },
        onError: (err) => {
          toast.error(err?.response?.data?.message);
        },
      });
    } else {
      toast.error("Please save invoice first");
    }
  };

  const handleInputChange = (e) => {
    const text = e.target.value;
    const mentionRegex = /@(\w+)_(\w+)_(\d+)/g;

    // Get the current cursor position
    const cursorPosition = textareaRef.current.selectionStart;

    // Check if backspace or delete is pressed
    if (
      e.nativeEvent.inputType === "deleteContentBackward" ||
      e.nativeEvent.inputType === "deleteContentForward"
    ) {
      // Find all mentions in the text
      const mentions = [...text.matchAll(mentionRegex)];

      // Check if the cursor is within any mention
      for (let mention of mentions) {
        const mentionStartIndex = mention.index;
        const mentionEndIndex = mentionStartIndex + mention[0].length;

        if (
          cursorPosition > mentionStartIndex &&
          cursorPosition <= mentionEndIndex
        ) {
          // Remove the entire mention
          const updatedText =
            text.slice(0, mentionStartIndex) + text.slice(mentionEndIndex);
          setComment(updatedText);
          updateTaggedStaff(updatedText);
          return;
        }
      }
    }

    setComment(text);
    updateTaggedStaff(text);

    // Check for "@" and show user list
    if (text.includes("@")) {
      setShowUserList(true);
      const query = text.split("@").pop().split(" ").shift();
      setStaffName(query);
    } else {
      setShowUserList(false);
    }
  };

  const updateTaggedStaff = (text) => {
    const mentionRegex = /@(\w+)_(\w+)_(\d+)/g;
    const mentionMatches = text.match(mentionRegex) || [];
    const updatedTaggedStaffId = [];

    mentionMatches.forEach((match) => {
      const parts = match.split("_");
      const userId = parseInt(parts[2], 10);
      if (!updatedTaggedStaffId.includes(userId)) {
        updatedTaggedStaffId.push(userId);
      }
    });

    setTaggedStaffId(updatedTaggedStaffId);
  };

  const handleUserSelect = (user) => {
    const userTag = `${user.first_name}_${user.last_name}_${user.id}`;
    const cursorPosition = textareaRef.current.selectionStart;
    const textBeforeCursor = comment.slice(0, cursorPosition);
    const textAfterCursor = comment.slice(cursorPosition);
    const updatedTextBeforeCursor = textBeforeCursor.replace(
      /@\w*$/,
      `@${userTag} `
    );

    setComment(updatedTextBeforeCursor + textAfterCursor);
    setShowUserList(false);
    if (!taggedStaffId.includes(user.id)) {
      setTaggedStaffId((prev) => [...prev, user.id]);
    }
    setStaffName("");
  };

  const updateCommentMutation = useUpdateItem(
    ApiEndPoint.BILLING_CREDIT_INVOICE
  );

  const handleUpdate = (data) => {
    const payload = {
      action: "patchInvoiceComments",
      id: data?.id,
      clinic_id: clinic?.id,
      backend: "True",
      comments: editComment,
      related_files: [],
      taged_staff: taggedStaffId,
    };
    updateCommentMutation.mutate(
      { data: payload },
      {
        onSuccess: (data) => {
          toast.success("Comment Updated Successfully");
          setIsEditComment(false);
          setEditComment("");
          setTaggedStaffId("");
        },
        onError: (error) => {
          toast.error("Failed to update comment");
        },
      }
    );
  };

  const handleEdit = (data, i) => {
    setIsEditComment(true);
    setSelectedIndex(i);
    setEditComment(data?.comments);
    setTaggedStaffId(data?.taged_staff || []);
  };

  const deleteCommentMutation = useSecureDeleteItem(
    ApiEndPoint.BILLING_CREDIT_INVOICE
  );

  const handleDelete = () => {
    const payload = {
      action: "delInvoiceComments",
      id: selectedId,
      clinic_id: clinic?.id,
      backend: "True",
    };
    deleteCommentMutation.mutate(payload, {
      onSuccess: (data) => {
        setSelectedId("");
        toast.success("Comment deleted successfully");
        setOpenDelete(false);
      },
      onError: () => {
        toast.error("Failed to delete comment");
      },
    });
  };

  // //("tagged id-----", taggedStaffId);

  const renderCommentText = (data) => {
    const commentParts = data.comments.split(/(@\w+_\w+_\d+)/g);

    return commentParts.map((part, index) => {
      if (part.startsWith("@")) {
        const match = part.match(/@(\w+)_(\w+)_(\d+)/);
        if (match) {
          const firstName = match[1];
          const lastName = match[2];
          const id = parseInt(match[3], 10);

          if (data.taged_staff.includes(id)) {
            const nameWithoutSymbols = `${firstName} ${lastName}`;
            return (
              <span key={index} className="text-blue-500 cursor-pointer">
                {nameWithoutSymbols}
              </span>
            );
          }
        }
      }
      return part;
    });
  };

  const handleEditInputChange = (e) => {
    const text = e.target.value;
    const mentionRegex = /@(\w+)_(\w+)_(\d+)/g;

    // Get the current cursor position
    const cursorPosition = textEditAreaRef.current.selectionStart;

    // Check if backspace or delete is pressed
    if (
      e.nativeEvent.inputType === "deleteContentBackward" ||
      e.nativeEvent.inputType === "deleteContentForward"
    ) {
      const mentions = [...text.matchAll(mentionRegex)];

      for (let mention of mentions) {
        const mentionStartIndex = mention.index;
        const mentionEndIndex = mentionStartIndex + mention[0].length;

        if (
          cursorPosition > mentionStartIndex &&
          cursorPosition <= mentionEndIndex
        ) {
          const updatedText =
            text.slice(0, mentionStartIndex) + text.slice(mentionEndIndex);
          setEditComment(updatedText);
          updateTaggedStaff(updatedText);
          return;
        }
      }
    }

    setEditComment(text);
    updateEditTaggedStaff(text);

    // Check for "@" and show user list
    if (text.includes("@")) {
      setShowEditUserList(true);
      const query = text.split("@").pop().split(" ").shift();
      setStaffName(query);
    } else {
      setShowEditUserList(false);
    }
  };

  const updateEditTaggedStaff = (text) => {
    const mentionRegex = /@(\w+)_(\w+)_(\d+)/g;
    const mentionMatches = text.match(mentionRegex) || [];
    const updatedTaggedStaffId = [];

    mentionMatches.forEach((match) => {
      const parts = match.split("_");
      const userId = parseInt(parts[2], 10);
      if (!updatedTaggedStaffId.includes(userId)) {
        updatedTaggedStaffId.push(userId);
      }
    });

    setTaggedStaffId(updatedTaggedStaffId);
  };

  const handleEditUserSelect = (user) => {
    const userTag = `${user.first_name}_${user.last_name}_${user.id}`;
    const cursorPosition = textEditAreaRef.current.selectionStart;
    const textBeforeCursor = editComment.slice(0, cursorPosition);
    const textAfterCursor = editComment.slice(cursorPosition);
    const updatedTextBeforeCursor = textBeforeCursor.replace(
      /@\w*$/,
      `@${userTag} `
    );

    setEditComment(updatedTextBeforeCursor + textAfterCursor);
    setShowEditUserList(false);
    if (!taggedStaffId.includes(user.id)) {
      setTaggedStaffId((prev) => [...prev, user.id]);
    }
    setStaffName("");
  };

  const handleCloseEdit = () => {
    setIsEditComment(false);
    setShowEditUserList("");
    setEditComment("");
    setTaggedStaffId("");
  };

  // //("comment---------", comment);

  return (
    <div>
      <div className="cu-general-info-heading">
        <span>
          <img
            style={{ width: "26px", height: "24px" }}
            src={cufrontIcons.cum}
            alt=""
          />
        </span>
        <span>CuM</span>
      </div>
      <div style={{ marginTop: "10px" }} className="">
        <div className="cu-cum-textarea-div">
          <textarea
            className="cu-cum-textarea"
            placeholder="Enter comment"
            value={comment}
            ref={textareaRef}
            onChange={handleInputChange}
            id="cum"
            disabled={viewId}
          ></textarea>
          <div className="pl-[6px]">
            Add <span style={{ color: "#0094FF" }}>File</span> |{" "}
            <span style={{ color: "#0094FF" }}>URL</span>
          </div>
        </div>
        <div className="cu-cum-info">
          Send Comment notification to a user by typing @name (ex. @JohnSmith)
        </div>
        {showUserList && (
          <ul className="border bg-white w-fit p-2">
            {staffLoading ? (
              <li>Loading...</li>
            ) : (
              <>
                {staffData?.map((item) =>
                  item.staff.map((staff) => (
                    <li
                      key={staff.id}
                      onClick={() => handleUserSelect(staff)}
                      className="cursor-pointer mt-1"
                    >
                      {staff.first_name} {staff.last_name}
                    </li>
                  ))
                )}
              </>
            )}
          </ul>
        )}
        <div className="w-full flex justify-end">
          <CuButton
            className={`border rounded-lg h-12 text-sm w-[176px] bg-[#C7EAC9]`}
            onClick={handleSaveComment}
            isLoading={postCommentMutation.isLoading}
            disabled={viewId}
          >
            Add Private Comment
          </CuButton>
        </div>
      </div>
      <div className="w-full">
        <div className="text-[#434343] my-2 font-bold">Comment</div>
        {data?.length > 0 &&
          data &&
          data.map((item, i) => {
            return (
              <div className="w-full mb-1" key={item.id}>
                {isEditComment && selectedIndex === i ? (
                  <div>
                    <textarea
                      className="w-full p-2 h-[86px] border"
                      placeholder="Enter comment"
                      value={editComment}
                      ref={textEditAreaRef}
                      onChange={handleEditInputChange}
                    ></textarea>
                    <div className="pl-[6px]">
                      Add <span style={{ color: "#0094FF" }}>File</span> |{" "}
                      <span style={{ color: "#0094FF" }}>URL</span>
                    </div>
                    {showEditUserList && (
                      <ul className="border bg-white w-fit p-2">
                        {staffLoading ? (
                          <li>Loading...</li>
                        ) : (
                          <>
                            {staffData?.map((item) =>
                              item.staff.map((staff) => (
                                <li
                                  key={staff.id}
                                  onClick={() => handleEditUserSelect(staff)}
                                  className="cursor-pointer mt-1"
                                >
                                  {staff.first_name} {staff.last_name}
                                </li>
                              ))
                            )}
                          </>
                        )}
                      </ul>
                    )}
                    <div className="w-full flex justify-end gap-4">
                      <CuButton
                        className={`h-12 px-4 border rounded-[5px]`}
                        onClick={handleCloseEdit}
                      >
                        Cancel
                      </CuButton>
                      <CuButton
                        className={`h-12 px-6 border rounded-[5px] bg-[#EBF8EC]`}
                        onClick={() => handleUpdate(item)}
                        isLoading={updateCommentMutation.isLoading}
                      >
                        Save
                      </CuButton>
                    </div>
                  </div>
                ) : (
                  <div className="w-full">
                    <div className="w-full p-2">
                      <div className="flex justify-between">
                        <div className="flex gap-2 items-center w-full">
                          <div className="w-[28px] h-[28px] border rounded-full bg-[#C7EAC9] text-white text-lg font-bold flex justify-center items-center">
                            {item?.user_created?.first_name[0]}
                          </div>
                          <div className="text-[#000000] font-bold">
                            {item?.user_created?.first_name}{" "}
                            {item?.user_created?.last_name}
                          </div>
                        </div>
                        <div className="flex gap-4">
                          <div className="text-[#616161] text-nowrap">
                            {moment(item.date_created).format("DD/MM/YY")} at{" "}
                            {moment(item.date_created).format("hh:mm A")}
                          </div>
                          {!viewId && (
                            <div className="flex gap-2">
                              <MdEdit
                                className="cursor-pointer"
                                size={20}
                                onClick={() => handleEdit(item, i)}
                              />
                              <IoClose
                                className="cursor-pointer"
                                size={21}
                                color="red"
                                onClick={() => (
                                  setSelectedId(item?.id), setOpenDelete(true)
                                )}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="text-xs leading-[13.8px] mt-2">
                        {renderCommentText(item)}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        {openDelete && selectedId && (
          <CuModal closeModal={() => setOpenDelete(false)}>
            <Confirmation
              heading={`Delete This Comment`}
              onCancel={() => setOpenDelete(false)}
              onClick={handleDelete}
              loading={deleteCommentMutation.isLoading}
            />
          </CuModal>
        )}
      </div>
    </div>
  );
};

export default CuM;
